<mat-form-field class="last-editor-form-field">
  <mat-label>LAST EDITOR</mat-label>
  <input
    matInput
    readonly
    class="last-editor-input"
    [class.has-logs]="hasLogs"
    [value]="displayValue"
    [matMenuTriggerFor]="hasLogs ? logMenu : null"
  />
</mat-form-field>
<mat-menu #logMenu="matMenu" panelClass="log-menu-panel">
  <mat-list role="list" dense>
    <mat-list-item
      role="listitem"
      *ngFor="let log of sortedLogs"
      style="text-transform: uppercase; font-size: smaller"
    >
      <span class="log-row">
        <ng-container *ngIf="log.item">{{ formatLogItem(log.item) }}&nbsp;&ndash;&nbsp;</ng-container>
        {{ log.initials }}
        &nbsp;&ndash;&nbsp;{{ log.date | date: 'MM/dd/yyyy': 'PST' }}
        <ng-container *ngIf="log.notes">&nbsp;&ndash;&nbsp;{{ log.notes }}</ng-container>
      </span>
    </mat-list-item>
  </mat-list>
</mat-menu>
